import { Injectable } from '@angular/core';
import { MatDatepickerIntl } from '@angular/material/datepicker';
import { getDatepickerLabels } from './app-locale';

@Injectable()
export class AppDatepickerIntl extends MatDatepickerIntl {
    setLanguage(language: string): void {
        const labels = getDatepickerLabels(language);
        this.calendarLabel = labels.calendarLabel;
        this.openCalendarLabel = labels.openCalendarLabel;
        this.prevMonthLabel = labels.prevMonthLabel;
        this.nextMonthLabel = labels.nextMonthLabel;
        this.prevYearLabel = labels.prevYearLabel;
        this.nextYearLabel = labels.nextYearLabel;
        this.prevMultiYearLabel = labels.prevMultiYearLabel;
        this.nextMultiYearLabel = labels.nextMultiYearLabel;
        this.switchToMonthViewLabel = labels.switchToMonthViewLabel;
        this.switchToMultiYearViewLabel = labels.switchToMultiYearViewLabel;
        this.changes.next();
    }
}
